import moment from 'moment';
export var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.prototype.format = function (date, format) {
        return moment(date.getTime()).format(format);
    };
    return DateFormatter;
}());
//# sourceMappingURL=date-formatter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/datepicker/date-formatter.js
// module id = 276
// module chunks = 3